(function () {

  'use strict';

  function pxAvailableValuesForMetadata($filter, $rootScope, $timeout, toastr, uuid, DataSource, DataSourceColumn, DataSourceRecord, DataSourceService) {
    return {
      restrict: 'EA',
      scope: {
        metadataField: '=',
        returnOk: '&',
        returnCancel: '&'
      },
      templateUrl: 'app/components/settings/workflows/availableValuesForMetadata/availableValuesForMetadata.template.html',
      link: function (scope) {

        scope.me = $rootScope.currentUser;
        const maxRowCount = 10000;
        scope.invalidKeys = new Set();
        scope.invalidValues = new Set();
        scope.AVAILABLE_VALUES = [];
        scope.orderByText = 'NONE';
        scope.reverse = false;
        const regexKey = /^[a-zA-Z_]\w*$/;
        scope.showProgress = false;
        scope.filenameForLookupCSV = document.getElementById('filenameForLookupCSV');

        const readerCSV = new FileReader();

        readerCSV.addEventListener('loadstart', onLoadStart);
        readerCSV.addEventListener('loadend', onLoadEnd);

        function onLoadStart(event) {
          scope.showProgress = true;
          scope.filenameForLookupCSV.parentElement.click();
        }

        function onLoadEnd(event) {
          const loadedValues = [];
          const rows = event.target.result.split('\n');
          if (rows.length) {
            const separator = getSeparator(rows[0]);
            for (let i = 0; i < rows.length && loadedValues.length < maxRowCount; ++i) {
              const cells = splitCSVRow(rows[i].trim(), separator);
              if (cells.length > 1) {
                const av = {};
                av.key = cells[0];
                av.value = cells[1];
                loadedValues.push(av);
              }
            }
          }
          if (loadedValues.length < maxRowCount) {
            loadedValues.push({ key: '', value: '' });
          }
          scope.AVAILABLE_VALUES = [];
          delayedArrayCopy({
            src: loadedValues,
            dest: scope.AVAILABLE_VALUES,
            copyIndex: 0,
            packetsize: 100,
            psm: 10,
            finish: function () { scope.showProgress = false; },
            iteration: function () { scope.filenameForLookupCSV.parentElement.click(); }
          });
        }

        function delayedArrayCopy(dp) {
          for (let i = 0; i < dp.packetsize && dp.copyIndex < dp.src.length; ++i, ++dp.copyIndex) {
            dp.dest.push(dp.src[dp.copyIndex]);
          }
          if (dp.copyIndex < dp.src.length) {
            dp.packetsize *= dp.psm ? dp.psm : 1;
            $timeout(delayedArrayCopy, 100, true, dp);
          } else if (dp.finish) {
            dp.finish();
          }
          if (dp.iteration) {
            dp.iteration();
          }
        }

        function getSeparator(row) {
          let separator = ',';
          let commaCount = 0;
          let semicolonCount = 0;
          let currentChar = '';
          for (let i = 0; i < row.length; ++i) {
            if (row.charAt(i) === '"') {
              if (currentChar === ',' || currentChar === ';') {
                return currentChar;
              }
              ++i;
              for (; i < row.length && row.charAt(i) !== '"';) {
                ++i;
              }
              currentChar = i < row.length - 1 ? row.charAt(i + 1) : '';
              if (currentChar === ',' || currentChar === ';') {
                return currentChar;
              }
            }
            currentChar = row.charAt(i);
            if (currentChar === ',') {
              ++commaCount;
            } else if (currentChar === ';') {
              ++semicolonCount;
            }
          }
          if (semicolonCount === 1 || (semicolonCount > 0 && commaCount === 0)) {
            separator = ';';
          }
          return separator;
        }

        function splitCSVRow(row, separator) {
          const values = [];
          for (let i = 0; i < row.length; ++i) {
            let currentValue = '';
            // Start state.
            for (; i < row.length && row.charAt(i) !== separator; ++i) {
              if (row.charAt(i) === '"') {
                // Enter the escape state until a comma is found.
                do {
                  currentValue += row.charAt(i);
                  ++i;
                  if (i >= row.length) {
                    // The line finished before we closed the escape state. Make sure we don't get stuck in an infinite loop.
                    break;
                  }
                } while (row.charAt(i) !== '"');
              }
              // Normal state.
              currentValue += row.charAt(i);
            }
            if (currentValue.startsWith('"') && currentValue.endsWith('"')) {
              currentValue = currentValue.substring(1, currentValue.length - 1);
            }
            // Replace all "" by " to unescape them.
            values.push(currentValue.split('""').join('"'));
          }
          return values;
        }

        scope.isKeyInvalid = function (index) {
          const key = scope.AVAILABLE_VALUES[index].key;
          if (index >= scope.AVAILABLE_VALUES.length - 1 && isRowEmpty(index)) {
            scope.invalidKeys.delete(index);
            return false;
          }
          if (key !== '') {
            for (let i = 0; i < scope.AVAILABLE_VALUES.length - 1; ++i) {
              if (key === scope.AVAILABLE_VALUES[i].key && i !== index) {
                scope.invalidKeys.add(index);
                return 'unique';
              }
            }
          }
          if (regexKey.test(key)) {
            scope.invalidKeys.delete(index);
            return false;
          }
          scope.invalidKeys.add(index);
          return (key === '') ? 'required' : 'pattern';
        };

        scope.isValueInvalid = function (index) {
          const value = scope.AVAILABLE_VALUES[index].value;
          if ((value !== '') || (index >= scope.AVAILABLE_VALUES.length - 1 && isRowEmpty(index))) {
            scope.invalidValues.delete(index);
            return false;
          }
          scope.invalidValues.add(index);
          return true;
        };

        function isRowEmpty(index) {
          return scope.AVAILABLE_VALUES[index].key === '' && scope.AVAILABLE_VALUES[index].value === '';
        }

        scope.isMovableUp = function (index) {
          return index > 0 && (index < scope.AVAILABLE_VALUES.length - 1 || !isRowEmpty(index));
        };

        scope.isMovableDown = function (index) {
          return index < scope.AVAILABLE_VALUES.length - 1 && (index !== scope.AVAILABLE_VALUES.length - 2 || !isRowEmpty(scope.AVAILABLE_VALUES.length - 1));
        };

        scope.isDeletable = function (index) {
          return index !== scope.AVAILABLE_VALUES.length - 1 || !isRowEmpty(index);
        };

        scope.moveUp = function (index) {
          if (index > 0) {
            const row = scope.AVAILABLE_VALUES[index];
            scope.AVAILABLE_VALUES.splice(index, 1);
            scope.AVAILABLE_VALUES.splice(index - 1, 0, row);
            scope.orderByText = '';
          }
        };

        scope.moveDown = function (index) {
          if (index < scope.AVAILABLE_VALUES.length - 1) {
            const row = scope.AVAILABLE_VALUES[index];
            scope.AVAILABLE_VALUES.splice(index, 1);
            scope.AVAILABLE_VALUES.splice(index + 1, 0, row);
            scope.orderByText = '';
          }
        };

        scope.deleteLine = function (index) {
          scope.AVAILABLE_VALUES.splice(index, 1);
          if (scope.AVAILABLE_VALUES.length === maxRowCount - 1 && !isRowEmpty(scope.AVAILABLE_VALUES.length - 1)) {
            scope.AVAILABLE_VALUES.push({ key: '', value: '' });
          }
        };

        scope.rowChanged = function (index) {
          const row = scope.AVAILABLE_VALUES[index];
          if (index >= scope.AVAILABLE_VALUES.length - 1 && (row.key !== '' || row.value !== '') && index < maxRowCount - 1) {
            scope.AVAILABLE_VALUES.push({ key: '', value: '' });
          }
        };

        function compareKeys(a, b) {
          if (a.key === '' && a.value === '') {
            return (b.key === '' && b.value === '') ? 0 : 1;
          }
          if (a.key < b.key) {
            return scope.reverse ? -1 : 1;
          }
          if (a.key > b.key) {
            return scope.reverse ? 1 : -1;
          }
          return 0;
        }

        function compareValues(a, b) {
          if (a.key === '' && a.value === '') {
            return (b.key === '' && b.value === '') ? 0 : 1;
          }
          if (a.value < b.value) {
            return scope.reverse ? -1 : 1;
          }
          if (a.value > b.value) {
            return scope.reverse ? 1 : -1;
          }
          return 0;
        }

        scope.changeOrderByValue = function (textValue) {
          if (textValue === 'KEY') {
            scope.AVAILABLE_VALUES.sort(compareKeys);
          } else if (textValue === 'VALUE') {
            scope.AVAILABLE_VALUES.sort(compareValues);
          }
          scope.reverse = !scope.reverse;
          scope.orderByText = textValue;
        };

        scope.importCSV = function (element) {
          const selectedFile = element?.files[0];
          scope.showProgress = true;
          if (angular.isDefined(selectedFile)) {
            readerCSV.readAsText(selectedFile);
          }
          element.value = '';
          element.parentElement.parentElement.click();
        };

        scope.onSaveButtonClick = function () {
          setAvailableValues();
          saveDataSource();
        };

        scope.onCancelButtonClick = function () {
          scope.returnCancel();
        };

        scope.onCloseButtonClick = function () {
          scope.returnCancel();
        };

        function setAvailableValues() {
          const returnValue = [];
          for (const availableValue of scope.AVAILABLE_VALUES) {
            if (availableValue.key !== '' && availableValue.value !== '') {
              returnValue.push({ key: availableValue.key, value: availableValue.value });
            }
          }
          scope.metadataField.availableValues = returnValue;
        }

        function saveDataSource() {
          if (scope.metadataField.dataSource?.id) {
            updateDataSource();
          } else {
            createDataSource();
          }
        }

        function createDataSource() {
          scope.metadataField.dataSource = new DataSource(undefined, 'DataSource_' + uuid.v4(), [
            new DataSourceColumn(undefined, 'key', 'Key', false, true, undefined, undefined),
            new DataSourceColumn(undefined, 'value', 'Value', true, true, undefined, undefined)
          ], scope.metadataField.availableValues.map(record => [record.key, record.value]));

          const dataSourceRequest = scope.metadataField.dataSource.toDataSourceRequest();
          DataSourceService.createDataSource(dataSourceRequest)
            .then((dataSourceResponse) => {
              onSaveDataSourceSuccess(dataSourceResponse);
            })
            .catch(() => {
              onSaveDataSourceFailure();
            });
        }

        function updateDataSource() {
          scope.metadataField.dataSource.records = scope.metadataField.availableValues.map(record => [record.key, record.value]);

          const dataSourceRequest = scope.metadataField.dataSource.toDataSourceRequest();
          DataSourceService.updateDataSource(scope.metadataField.dataSource.id, dataSourceRequest)
            .then((dataSourceResponse) => {
              onSaveDataSourceSuccess(dataSourceResponse);
            })
            .catch(() => {
              onSaveDataSourceFailure();
            });
        }

        function onSaveDataSourceSuccess(dataSourceResponse) {
          toastr.success($filter('translate')('DataSourceSaved'));
          scope.metadataField.linkRecords = dataSourceResponse._links['px:records'].href;
          scope.metadataField.dataSource = new DataSource().fromDataSourceResponse(dataSourceResponse);
          // This is required, because saving the data source will change the record IDs.
          loadDataSourceRecords();
        }

        function onSaveDataSourceFailure() {
          toastr.error($filter('translate')('FailedToSaveDataSource'));
        }

        function loadDataSourceRecords() {
          DataSourceService.getDataSourceRecords(scope.metadataField.linkRecords)
            .then(function (dataSourceRecordResponses) {
              scope.metadataField.availableValues = dataSourceRecordResponses.map(dataSourceRecordResponse =>
                new DataSourceRecord().fromDataSourceRecordResponse(dataSourceRecordResponse));
              scope.metadataField.defaultValue = undefined;
              scope.returnOk();
            })
            .catch(function () {
              toastr.error($filter('translate')('FailedToLoadDataSourceRecords'));
            });
        }

        (function () {
          scope.AVAILABLE_VALUES = [];
          if (scope.metadataField.availableValues?.length) {
            for (const availableValue of scope.metadataField.availableValues) {
              scope.AVAILABLE_VALUES.push({ key: availableValue.key, value: availableValue.value });
            }
          }
          if (scope.AVAILABLE_VALUES.length < maxRowCount) {
            scope.AVAILABLE_VALUES.push({ key: '', value: '' });
          }
        })();
      }
    };
  }

  pxAvailableValuesForMetadata.$inject = [
    '$filter', '$rootScope', '$timeout', 'toastr', 'uuid', 'DataSource', 'DataSourceColumn', 'DataSourceRecord', 'DataSourceService'
  ];

  angular
    .module('printix-admin')
    .directive('pxAvailableValuesForMetadata', pxAvailableValuesForMetadata);

})();
